import React, { useState, useEffect } from 'react';
import {
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Chip,
  TableRow,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  LinearProgress,
  Card,
  CardContent,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExerciseDetails from "./ExerciseDetails";
import ExerciseLogDetails from "./ExerciseLogDetails";

const ExercisesLastPerformed = () => {
  const [exercises, setExercises] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [weekSummary, setWeekSummary] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(''); // New state for selected location

  const muscleColorMap = {
    "Chest": "indianred", "Back": "green", "Legs": "blue", "Arms": "yellow", "Biceps": "magenta", "Triceps": "brown", "Shoulders": "orange", // Add more muscle groups and colors as needed
  };

  useEffect(() => {
    fetch('http://gymbackend-env.eba-kw3jn3jh.us-west-2.elasticbeanstalk.com/exercises/last_performed/')
      .then(response => response.json())
      .then(data => {
        setExercises(data);
        if (data.length > 0) {
          setSelectedLocation(data[0].exercise_location); // Set default location to the first location in the list
        }
      });
  }, []);

  useEffect(() => {
    fetch('http://gymbackend-env.eba-kw3jn3jh.us-west-2.elasticbeanstalk.com/exercises/last_week/')
      .then(response => response.json())
      .then(data => {
        setWeekSummary(data);
      });
  }, []);

  const handleAccordionChange = (exerciseId) => (event, isExpanded) => {
    if (isExpanded && !isLoading) {
      setIsLoading(true);
      fetch(`http://gymbackend-env.eba-kw3jn3jh.us-west-2.elasticbeanstalk.com/exercises/${exerciseId}/logs/`)
        .then(response => response.json())
        .then(data => {
          setLogs(data);
          setIsLoading(false);
          setExpanded(exerciseId);
        });
    } else {
      setExpanded(false);
    }
  };

  const handleLocationChange = (event, newLocation) => {
    setSelectedLocation(newLocation);
  };

  const progressForMuscle = (count) => {
    const percentage = (count / 5) * 100;
    return Math.min(percentage, 100); // Ensure it doesn't go over 100%
  };

  const uniqueLocations = [...new Set(exercises.map(exercise => exercise.exercise_location))];

  return (<Grid container spacing={0} justifyContent="center">
      <Grid item xs={12}>
        <Tabs
          value={selectedLocation}
          onChange={handleLocationChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          {uniqueLocations.map((location, index) => (<Tab key={index} value={location} label={location}/>))}
        </Tabs>
      </Grid>
      <Grid item xs={12} md={6}>
        {Object.keys(weekSummary).map((muscle) => (<Card key={muscle} style={{ margin: '5px' }}>
            <CardContent>
              <Box display="flex" alignItems="center">
                <Typography variant="h6" style={{ marginRight: '20px', minWidth: '100px' }}>{muscle}:</Typography>
                <Box width="100%" mr={1}>
                  <LinearProgress variant="determinate" value={progressForMuscle(weekSummary[muscle].count)}/>
                </Box>
                <Box minWidth={35}>
                  <Typography variant="body2" color="textSecondary">{`${Math.round(progressForMuscle(weekSummary[muscle].count))}%`}</Typography>
                </Box>
              </Box>
              <Typography variant="body2">{`Exercises: ${weekSummary[muscle].exercises.join(', ')}`}</Typography>
            </CardContent>
          </Card>))}
      </Grid>
      <Grid item xs={12} md={6} style={{ borderRadius: 0 }}>
        <TableContainer component={Paper} style={{ borderRadius: 0 }}>
          <Table>
            <TableBody>
              {exercises.filter(exercise => exercise.exercise_location === selectedLocation).map((exercise, index) => (<TableRow key={index}>
                  <TableCell component="th" scope="row">
                    <Accordion expanded={expanded === exercise.exercise_id} onChange={handleAccordionChange(exercise.exercise_id)}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Grid container alignItems="flex-end">
                          <Grid item xs={10}>
                            <Typography>{exercise.exercise_name} ({exercise.last_performed})</Typography>
                          </Grid>
                          <Grid style={{ textAlign: "right" }} item xs={2}>
                            <Chip
                              style={{
                                backgroundColor: muscleColorMap[exercise.exercise_muscles] || "defaultColor", color: "white", width: "100%"
                              }}
                              label={exercise.exercise_muscles}
                            />
                          </Grid>
                        </Grid>
                      </AccordionSummary>
                      <ExerciseDetails logs={logs} exercise_id={exercise.exercise_id}/>
                    </Accordion>
                  </TableCell>
                </TableRow>))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>);
};

export default ExercisesLastPerformed;
